import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { BalanceAdjustmentItem } from 'donor-elf-web/routes/admin/balance-adjustments';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validateNumber } from 'ember-changeset-validations/validators';

interface ComponentArgs {
  item: BalanceAdjustmentItem;
}

const balanceAdjustmentValidation = {
  newAdjustment: validateNumber({
    allowBlank: true,
    message: 'Needs to be a number',
  }),
  newBalance: validateNumber({
    allowBlank: true,
    message: 'Needs to be a number',
  }),
};

export default class BalanceAdjustmentRowComponent extends Component<ComponentArgs> {
  @tracked changeset?: any;

  @action
  createChangeset() {
    if (!this.changeset) {
      this.changeset = new Changeset(
        this.args.item.balanceAdjustment,
        lookupValidator(balanceAdjustmentValidation),
        balanceAdjustmentValidation,
      );
    }
  }

  @action
  clearChangeset() {
    this.changeset?.set('newBalance', undefined);
    this.changeset?.set('newAdjustment', undefined);
  }
}
